


<template>
    <div class="card card-w shadow">
        <slot />
        <div class="card-body">
            <h5 class="card-title"> {{ title }}</h5>
            <ul v-for="item in items" :key="item" class="list-group list-group-flush">
                <li class="list-group-item"><i class="bi bi-check2-circle"></i>{{ item }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SideCardContainer',
    props: {
        title: String,
        items: Array,
    },
}
</script>

<style lang="scss" scoped>
    i {
        font-size: 1rem;
        margin-right: 15px;
    }

    .card-w {
        width: 400px;
    }

    @media screen and (max-width: 800px) {
        .card-w {
            width: 80%;
        }
    }
</style>